/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react'
import Switch from 'react-switch'
import UIkit from 'uikit'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getEnabledRewardsStatus, getCredits, enableRewards, getRewardsCatalogByOrganization } from 'app/state/modules/rewards'

import Loader from 'app/views/components/Loader'
import OrganizationLayout from '../components/Layout'
import { RewardsSettingContainer } from './style';
import { RewardOption } from '../../MyPlan/style';
import ModalGiftCard from 'app/views/components/Modals/Info/ModalGiftCard';
import Statistics from 'app/views/components/Statistics'
import Icon from 'app/views/components/Icon'
import LoadingDots from 'app/views/components/LoadingDots'

const RewardsSetting = (props) => {
  const organizationUuid = props.match.params.organization_uuid
  const [type, setType] = useState('');
  const [allowClaim, setAllowClaim] = useState(true);
  const rewards = [
    {
      id: 'giftCard',
      imgSrc: "/static/images/rewards/gift.png",
      desc: "$20 Gift Card",
      class: "gift",
      modal: "Gift Card Options"
    },
    {
      id: 'crypto',
      imgSrc: "/static/images/rewards/bitcoin.png",
      desc: "Crypto",
      class: "crypto",
      modal: "Crypto Options"
    },
    // {
    //   id: 2,
    //   imgSrc: "/static/images/rewards/t-shirt.png",
    //   desc: "T-Shirt",
    //   class: "tshirt",
    //   modal: "T Shirt Options"
    // },
    // {
    //   id: 3,
    //   imgSrc: "/static/images/rewards/mugs.png",
    //   desc: "Mug",
    //   class: "mug",
    // },
    // {
    //   id: 4,
    //   imgSrc: "/static/images/rewards/phone-cases.png",
    //   desc: "Phone Case",
    //   class: "phone",
    // }
  ];

  useEffect(() => {
    props.getEnabledRewardsStatus(organizationUuid)
    props.getCredits(organizationUuid)
    props.getRewardsCatalogByOrganization(organizationUuid)
  }, [])
  const { giftCard, crypto } = props.catalogByOrganizationId[organizationUuid] || {}
  const { rewardsAdminStatus: rewardsEnabled, currentOrganizationTotalPurchased, currentOrganizationTotalActive, currentOrganizationTotalClaimed } = props
  const renderRewardTypes = (reward) => {
    if (reward.id === 'giftCard') {
      return `Gift Card (${parseFloat(props.catalogByOrganizationId[organizationUuid].giftCard[0].giftCard.amount.amount).toFixed(0)} ${props.catalogByOrganizationId[organizationUuid].giftCard[0].giftCard.amount.currency})`
    }
    if (reward.id == 'crypto') {
      return `Crypto (${parseFloat(props.catalogByOrganizationId[organizationUuid].crypto[0].crypto.currencyValue.amount).toFixed(0)} ${props.catalogByOrganizationId[organizationUuid].crypto[0].crypto.currencyValue.currency})`
    }
  }
  return (
    <OrganizationLayout
      isLoading={props.rewardsAdminStatusLoading}
      active="rewards"
      {...props}
    >
      {
        props.loadingCredits ? (
          <Loader visible />
        ) : (
          <>
            <RewardsSettingContainer>
              <h1 className="uk-margin-remove-bottom">HackEDU Rewards</h1>
              <span className="uk-margin-remove-top uk-text-italic">Manage your organization’s reward settings</span>
              <hr />
              <h3>Credits</h3>
              <div className="uk-flex uk-flex-row uk-flex-around">
                <Statistics
                  header={typeof currentOrganizationTotalPurchased === 'number' ? currentOrganizationTotalPurchased : '-'}
                  content="Purchased Credits"
                />
                <Statistics
                  header={typeof currentOrganizationTotalClaimed === 'number' ? currentOrganizationTotalClaimed : '-'}
                  content="Claimed Credits"
                />
                <Statistics
                  header={typeof currentOrganizationTotalActive === 'number' ? currentOrganizationTotalActive : '-'}
                  content="Active Credits"
                />
              </div>

              <h4>Settings</h4>

              <p className="uk-margin-remove-bottom uk-margin-top">Available Rewards</p>
              <small>
                These are the rewards available for your developers. To change
                these options, reach out to your customer success manager or email
                &nbsp;
                <strong>
                  <a href="mailto:support@hackedu.com">support@hackedu.com</a>.
                </strong>
              </small>
              <br />

              {Object.keys(props.catalogByOrganizationId[organizationUuid] || {}).length === 0 && <small className="uk-text-italic">Reward options have not been configured.</small>}
              <div>
                <div className="uk-flex uk-flex-row uk-flex-left uk-flex-middle uk-margin-top">
                  {rewards.filter((item) => {
                    if (Object.keys(props.catalogByOrganizationId[organizationUuid] || {}).includes(item.id)) {
                      return true
                    }
                    return false
                  }).map(reward => (
                    <div className="uk-width-1-4 uk-flex uk-flex-column uk-flex-middle uk-flex-center" key={reward.desc}>
                      <div className="uk-padding-small">
                        <img src={reward.imgSrc} alt={reward.desc} style={{ height: 140 }} />
                      </div>
                      <p className="uk-text-emphasis uk-margin-remove uk-text-bold uk-text-italic">
                        {renderRewardTypes(reward)}
                      </p>
                      <a
                        className="uk-text-small"
                        data-uk-toggle="target: #modal-gift-cards"
                        onClick={() => {
                          setType(reward.modal)
                        }}
                      >
                        Preview
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <hr />
              <div className="uk-width-2-3">
                <p className="uk-margin-remove-bottom uk-margin-top">Enable HackEDU Rewards</p>
                <div className="uk-inline uk-flex uk-flex-between">
                  <small className="uk-text-top">
                    {props.loadingEnabling ? <span className={rewardsEnabled ? 'uk-text-danger' : 'uk-text-primary'}>{`${(rewardsEnabled ? 'Disabling' : 'Enabling')} rewards`} <LoadingDots /></span> : 'Allow your users to claim rewards?'}
                  </small>
                  <Switch
                    onChange={(active) => {
                      if (props.currentOrganizationTotalActive === 0) {
                        UIkit.modal.alert('<h2>Rewards can\'t be activated</h2><p>Your organization has no Rewards Credits available. Please contact your customer support manager or email <a href="mailto:support@hackedu.com">support@hackedu.com</a> to add credits.</p>')
                      } else {
                        props.enableRewards(organizationUuid, active)
                      }
                    }}
                    disabled={props.loadingEnabling}
                    checked={rewardsEnabled && currentOrganizationTotalPurchased > 0}
                    id="claim-rewards"
                    offColor="#999999"
                    onColor="#1e87f0"
                    checkedIcon={false}
                    uncheckedIcon={false}
                  />
                </div>
                <p className="uk-margin-remove-bottom uk-margin-top">Add Credits</p>
                <small>Your customer success manager can help add credits to your account. Please email <strong><a href="mailto:support@hackedu.com">support@hackedu.com</a>.</strong></small>
                <p className="uk-margin-remove-bottom uk-margin-top">Reward Reports</p>
                <small>See who has claimed rewards from your team in the Reports menu.</small>
                <br />
                <button
                  type="button"
                  className="uk-button uk-button-small uk-button-primary"
                  onClick={() => props.history.push(`/admin/${organizationUuid}/reports/rewards`)}
                >
                  View Report
                </button>

                <p className="uk-margin-remove-bottom uk-margin-top">See Additional Reward Options</p>
                <small>These are additional Reward options you can offer to your users. See the "Available Rewards" section above to view the current options you are offering.</small>
                <br />
                <small>
                  To add change your reward options, please reach out to your customer success manager or email
                  {' '}
                  <a href="mailto:support@hackedu.com">support@hackedu.com</a>
                </small>
                <br />
                <a
                  className="uk-button uk-button-primary uk-button-small"
                  data-uk-toggle="target: #all-available-gift-cards-modal"
                >
                  Preview
                </a>
                <ModalGiftCard id="all-available-gift-cards-modal" type="allAvailable" title="Gift Card Options" />
              </div>

            </RewardsSettingContainer>
            <ModalGiftCard title={type} />
          </>
        )
      }
    </OrganizationLayout>
  )
}

const mapStateToProps = ({ hacker, rewards }) => ({
  organizations: hacker.organizationsList,
  organizationsHash: hacker.organizationsHash,
  currentOrganizationTotalClaimed: rewards.currentOrganizationTotalClaimed,
  currentOrganizationTotalActive: rewards.currentOrganizationTotalActive,
  currentOrganizationTotalPurchased: rewards.currentOrganizationTotalPurchased,
  loadingEnabling: rewards.loadingEnabling,
  rewardsAdminStatusLoading: rewards.rewardsAdminStatusLoading,
  rewardsAdminStatus: rewards.rewardsAdminStatus,
  loadingCredits: rewards.loadingCredits,

  catalogByOrganizationId: rewards.catalogByOrganizationId,
})

export default withRouter(connect(mapStateToProps, {
  getEnabledRewardsStatus,
  getCredits,
  enableRewards,
  getRewardsCatalogByOrganization,
})(RewardsSetting))
